import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as BoardAction from './BoardAction';
import simpleDotProp from '../simpleDotProp';
import {
  PostListStateToProps,
  PostListDispatchToProps,
} from './PostListDefaultProps';
import { showPlatform } from './PostShowPlatform';

const PostMoreListInjector =
  (stateToProps = null, dispatchToProps = null) =>
  (WrapperComponent) => {
    const HOCComponent = class _HOCComponent extends Component {
      componentDidUpdate(prevProps, prevState) {
        if (this.props.initLoad === true) {
          if (
            JSON.stringify(prevProps.history.query) !==
            JSON.stringify(this.props.history.query)
          ) {
            const query = { ...this.props.history.query };
            this.props.getPostMoreList(1, query);
          }
        }
      }

      componentDidMount() {
        if (this.props.initLoad === true) {
          const query = { ...this.props.history.query };
          if (this.props.postMoreList.results.length === 0) {
            this.props.getPostMoreList(1, query);
          }
        }
      }

      render() {
        return <WrapperComponent {...this.props} />;
      }
    };

    HOCComponent.defaultProps = {
      initLoad: true,
    };

    const mapDispatchToProps = (dispatch, ownProps) => {
      const { boardType, boardName, listPage, pageSize } = ownProps;
      let props = {};
      if (dispatchToProps !== null) {
        props = dispatchToProps(dispatch, ownProps);
      }
      return {
        getPostMoreList: (pageNo, pageQuery) => {
          let newQuery = {};
          if (pageQuery) {
            newQuery = { ...pageQuery, pagename: listPage };
          } else {
            newQuery = { pagename: listPage };
          }
          newQuery = showPlatform(ownProps, newQuery);
          return dispatch(
            BoardAction.getPostMoreList(
              boardType,
              boardName,
              pageNo,
              pageSize,
              newQuery
            )
          );
        },
        getPostInfoForMoreList: (postId) => {
          return dispatch(BoardAction.getPostInfoForMoreList(postId));
        },
        getPostLikeMoreList: (actorId, postIdList) => {
          return dispatch(
            BoardAction.getPostLikeMoreList(
              boardType,
              boardName,
              actorId,
              postIdList
            )
          );
        },
        ...PostListDispatchToProps(dispatch, ownProps),
        ...props,
      };
    };

    const mapStateToProps = (state, ownProps) => {
      let props = {};
      if (stateToProps !== null) {
        props = stateToProps(state, ownProps);
      }
      return {
        postMoreList: simpleDotProp.deepCopy(state.BoardReducer.postMoreList),
        postInfoForMoreList: simpleDotProp.deepCopy(
          state.BoardReducer.postInfoForMoreList
        ),
        postLikeMoreList: simpleDotProp.deepCopy(
          state.BoardReducer.postLikeMoreList
        ),
        pageNo: state.BoardReducer.pageNo,
        ...PostListStateToProps(state, ownProps),
        ...props,
      };
    };

    return connect(mapStateToProps, mapDispatchToProps)(HOCComponent);
  };

export default PostMoreListInjector;
